import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pioneer-route-not-found',
  templateUrl: './route-not-found.component.html',
  styleUrls: [ './route-not-found.component.css' ]
})
export class RouteNotFoundComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/route-not-found/route-not-found.component.ts